var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanQuartiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17798 20.5339V10.8257C8.17798 10.1235 8.45693 9.45001 8.95347 8.95347C9.45001 8.45693 10.1235 8.17798 10.8257 8.17798C11.5279 8.17798 12.2014 8.45693 12.6979 8.95347C13.1944 9.45001 13.4734 10.1235 13.4734 10.8257V20.5339",
    stroke: "#737373",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3596 19.6514V25.3881C29.3596 30.9933 24.8153 35.5376 19.2101 35.5376H18.3275C12.7223 35.5376 8.17798 30.9933 8.17798 25.3881V19.6514",
    stroke: "#737373",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4735 23.1816V18.7688C13.4735 18.0666 13.7525 17.3931 14.249 16.8966C14.7455 16.4 15.419 16.1211 16.1212 16.1211C16.8234 16.1211 17.4969 16.4 17.9934 16.8966C18.49 17.3931 18.7689 18.0666 18.7689 18.7688M18.7689 18.7688V23.1816M18.7689 18.7688C18.7689 18.0666 19.0479 17.3931 19.5444 16.8966C20.041 16.4 20.7144 16.1211 21.4166 16.1211C22.1188 16.1211 22.7923 16.4 23.2888 16.8966C23.7854 17.3931 24.0643 18.0666 24.0643 18.7688M24.0643 18.7688V23.1816M24.0643 18.7688C24.0643 18.0666 24.3433 17.3931 24.8398 16.8966C25.3364 16.4 26.0098 16.1211 26.712 16.1211C27.4143 16.1211 28.0877 16.4 28.5842 16.8966C29.0808 17.3931 29.3597 18.0666 29.3597 18.7688V23.1816",
    stroke: "#737373",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6514 10.8257C19.6534 8.93644 19.0472 7.09673 17.9224 5.57882C17.1025 4.46814 16.0331 3.56563 14.8004 2.944C13.5677 2.32237 12.2062 1.99902 10.8257 2C9.44499 1.99888 8.08335 2.32217 6.8505 2.9438C5.61766 3.56543 4.54812 4.46802 3.72808 5.57882C2.60365 7.09687 1.99774 8.93655 2.00001 10.8257",
    stroke: "#737373",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQuartiary);
export default __webpack_public_path__ + "static/media/scan-quartiary.aee9da243fcfa85b953dd67d235fc067.svg";
export { ForwardRef as ReactComponent };